export default __webpack_public_path__ + "static/media/chopy_s.531a69f8.jpg";